import { Box, Typography, FormHelperText } from '@material-ui/core';
import { Rating } from '@material-ui/lab';
import { FieldExtensionComponentProps } from '../../../extensions/types';

interface StarPickerUiOptions {
  precision?: 0.5 | 1;
  maxValue?: number;
}

export type StarPickerProps = FieldExtensionComponentProps<
  number,
  StarPickerUiOptions
>;

export const StarPicker = ({
  onChange,
  formData,
  schema,
  uiSchema,
  rawErrors,
  disabled,
}: StarPickerProps) => {
  const effectivePrecision = uiSchema?.['ui:options']?.precision ?? 1;
  const effectiveMaxValue = uiSchema?.['ui:options']?.maxValue ?? 5;
  const effectiveTitle = schema?.title ?? '';

  const scale = Math.max(1, effectiveMaxValue);
  const normalizedValue = formData ? formData / (scale / 5) : 0;

  const handleChange = (newValue: number | null) => {
    if (newValue === null) {
      onChange(undefined);
    } else {
      const denormalizedValue = newValue * (scale / 5);
      onChange(denormalizedValue);
    }
  };

  return (
    <Box>
      <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 4 }}>
        {effectiveTitle}
      </Typography>
      <Box style={{ marginTop: 8, marginBottom: 8 }}>
        <Rating
          value={normalizedValue}
          onChange={(_, newValue) => handleChange(newValue)}
          max={5}
          disabled={disabled}
          precision={effectivePrecision}
          style={{ fontSize: '32px' }}
        />
      </Box>
      {rawErrors && rawErrors.length > 0 && (
        <FormHelperText error style={{ width: '100%' }}>
          {rawErrors[0]}
        </FormHelperText>
      )}
    </Box>
  );
};
